import { TabSectionPropType, Mediums, GoalAnalyticsMetricKey } from 'modules/iterableGoals/types';

import { colors } from 'ui/theme';
import {
  calculateMediumValuesTotal,
  getMediumIcon,
  sortMediumData,
} from 'modules/iterableGoals/utils';
import { useSelector } from 'react-redux';
import { getGoalContributionsByMediumMetrics } from 'modules/iterableGoals/ducks/selectors';
import { SMALL_CARD_HEIGHT } from 'modules/iterableGoals/constants/common';
import { useReportingContext } from 'modules/iterableGoals/contexts';
import { ChartsContainer } from './Styled';
import { AnalyticsCard } from '../AnalyticsCard';
import { GoalContributionsByMediumChart } from './GoalContributionsByMediumChart';
import { OverallStatsHeader } from './OverallStatsHeader';
import { MediumMetricsRow } from './MediumMetricsRow';

export const GoalContributionsByMedium = ({
  loading,
  error,
  reFetchGoalAnalyticsData,
}: TabSectionPropType) => {
  const { isRevenue, getReportingTranslation } = useReportingContext();
  const { metrics } = useSelector(getGoalContributionsByMediumMetrics);
  const sendsData: Mediums = metrics?.[GoalAnalyticsMetricKey.TOTAL_SENT] || {};
  const contributionsData: Mediums = metrics?.[GoalAnalyticsMetricKey.TOTAL_GOAL_CONVERSIONS] || {};
  const revenueData: Mediums = metrics?.[GoalAnalyticsMetricKey.REVENUE] || {};
  const totalSends = calculateMediumValuesTotal(sendsData);
  const totalContributions = calculateMediumValuesTotal(contributionsData);
  const totalRevenue = calculateMediumValuesTotal(revenueData);
  const sortedContributionsData = sortMediumData(contributionsData);
  const sortedRevenueData = sortMediumData(revenueData);
  const rowData = isRevenue ? sortedRevenueData : sortedContributionsData;
  const totalReportedValue = isRevenue ? totalRevenue : totalContributions;

  return (
    <AnalyticsCard
      title={getReportingTranslation('title.analytics.goalContributionsByMedium')}
      height={SMALL_CARD_HEIGHT}
      loading={loading}
      error={error}
      handleReload={reFetchGoalAnalyticsData}
    >
      <ChartsContainer>
        <OverallStatsHeader totalReportedValue={totalReportedValue} totalSends={totalSends} />
        <GoalContributionsByMediumChart
          contributionsData={[
            ...(isRevenue ? sortedRevenueData : sortedContributionsData),
          ].reverse()}
          totalContributions={totalReportedValue}
        />
        {rowData?.map(([medium, data, color]) => {
          const sends = sendsData[medium]?.value;
          const Icon = getMediumIcon(medium);

          return (
            <MediumMetricsRow
              key={medium}
              color={color}
              medium={medium}
              mediumData={data}
              sends={sends}
              icon={<Icon height={21} width={21} color={colors.grey50} />}
            />
          );
        })}
      </ChartsContainer>
    </AnalyticsCard>
  );
};
